import React from 'react';
import { Link } from 'react-router-dom';
import { Activity, ArrowLeft } from 'lucide-react';
import { Button } from '../components/ui/button';

const PageLayout = ({ title, children }) => {
  return (
    <div className="min-h-screen bg-slate-50">
      {/* Header */}
      <header className="bg-slate-900 py-4">
        <div className="container mx-auto px-6">
          <div className="flex items-center justify-between">
            <Link to="/" className="flex items-center gap-3">
              <div className="w-10 h-10 rounded-lg bg-teal-500 flex items-center justify-center">
                <Activity className="h-5 w-5 text-white" />
              </div>
              <div className="flex flex-col">
                <span className="font-manrope font-bold text-white text-lg leading-tight">SignalPath</span>
                <span className="text-slate-400 text-xs">A Digital Health Applications Company</span>
              </div>
            </Link>
            <Link to="/">
              <Button variant="outline" className="text-white border-slate-600 hover:bg-slate-800">
                <ArrowLeft className="h-4 w-4 mr-2" />
                Back to Home
              </Button>
            </Link>
          </div>
        </div>
      </header>

      {/* Content */}
      <main className="container mx-auto px-6 py-16 max-w-4xl">
        <h1 className="font-manrope text-4xl font-bold text-slate-900 mb-8">{title}</h1>
        <div className="prose prose-slate max-w-none">
          {children}
        </div>
      </main>

      {/* Simple Footer */}
      <footer className="bg-slate-900 py-8">
        <div className="container mx-auto px-6 text-center">
          <p className="text-slate-400 text-sm">
            © {new Date().getFullYear()} SignalPath Digital Health Applications, LLC. All rights reserved.
          </p>
        </div>
      </footer>
    </div>
  );
};

export default PageLayout;
